import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SoftwareService } from '../../../services/software.service';
import { switchMap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { SoftwareActions } from '../actions/software.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';

@Injectable()
export class SoftwareEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private softwareService = inject(SoftwareService);

  constructor() {}

  ReadSoftwareVersionData$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SoftwareActionTypes.GetSoftwareVersionData),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      return this.softwareService.ReadSoftwareVersionData(payload).pipe(
        switchMap((res) => {
          if (res.result) {
            return [new featureActions.UpsertSoftwareVersionData(res.msg.body)];
          } else {
            return of(new featureActions.GetSoftwareVersionDataFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetSoftwareVersionDataFail());
        })
      );
    })
  ));
}
